import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.currentSelection = this.element.value;

    this.element.addEventListener("input", (evt) => {
      if (this.element.value !== this.currentSelection) {
        if (this.element.value.length) {
          window.location.href = "/referanser/kategori/" + this.element.value;
        } else {
          window.location.href = "/referanser/";
        }
      }
    });
  }
}
